var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" I'm a success alert. ")]),_c('v-btn',{on:{"click":_vm.handleClick}},[_vm._v("Normal Button")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }